import { connect } from 'react-redux'
import { newsletterSendRequest, newsletterUpdateNewsletterCurrentWeek, uiSetRequestOverlayType, uiSetRequestOverlayRequest, uiRequestOverlayReset, newsletterAddNewsletterItem, newsletterDeleteNewsletterItem, newsletterReorderNewsletterItem, newsletterDeleteElement, newsletterUpdateRequest, newsletterCancelRequest } from '../../../actions';
import PageNewsletterCampaign from '../present/PageNewsletterCampaign';
import getData from '../../../functions/getData';
import toJS from '../../../containers/general/toJS.js';
import { PROGRAM_CLI_MOVIES_ORDER, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CINEMAS, UI_GENERAL, FEATURES, UI_PROGRAM, AUTH_CAPS, PROGRAM_ADS_ITEMS, PROGRAM_HIGHLIGHTS, PROGRAM_ATTRIBUTES, CLI_CURRENT_CINEMA_ID, CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, PROGRAM_PERFORMANCES, PRINT_WEEKS } from '../../../constants/state';
import { OVERLAY_NEWSLETTER_SEND, OVERLAY_NEWSLETTER_YES_NO } from '../../../constants/overlayTypes';
import actionTypes from '../../../actions/actionTypes';
import canEditProgram from '../../../functions/canEditProgram.js';
import hasCap from '../../../functions/hasCap.js';
import { EDIT_NEWSLETTER_CAP } from '../../../constants/caps.js';
import filterItemsByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByCinema.js';
import filterItemsByOrder from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByOrder.js';
import getOptionalCinemaId from '../../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId.js';
import filterMoviesByWeekAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByWeekAndCinema.js';
import filterAttributesByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterAttributesByCinema.js';
import findWeekObWithIsoWeek from '../../../functions/findWeekObWithIsoWeek.js';

const mapStateToProps = (state, ownProps) => ({
    weeks: getData(state, PRINT_WEEKS),
    campaign: state.getIn(['newsletterServerData', 'campaigns', 'data', 'items', ownProps.match.params.campaignId]),

    sendStatus: state.getIn(['newsletterLocalData', 'status']),
    sendError: state.getIn(['newsletterLocalData', 'error']),
    hasChanges: state.getIn(['newsletterLocalData', 'hasChanges']),
    currentWeek: state.getIn(['newsletterLocalData', 'newsletters', 'items', ownProps.match.params.campaignId, 'currentWeek']),
    selectedItems: state.getIn(['newsletterLocalData', 'newsletters', 'items', ownProps.match.params.campaignId, 'items']),

    cinemas: getData(state, PROGRAM_CINEMAS),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),

    movieOrder: getData(state, PROGRAM_CLI_MOVIES_ORDER),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    elementsTextData: state.getIn(['newsletterLocalData', 'texts', 'items']),
    elementsImagesData: state.getIn(['newsletterLocalData', 'images', 'items']),
    attributesData: getData(state, PROGRAM_ATTRIBUTES),
    adsData: getData(state, PROGRAM_ADS_ITEMS),
    highlightsData: getData(state, PROGRAM_HIGHLIGHTS),
    performancesData: getData(state, PROGRAM_PERFORMANCES),

    hasSendNewsletter: getData(state, [FEATURES, 'has_newsletter_send']),
    caps: getData(state, AUTH_CAPS),

    uiRequestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),    
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    updateWeek: week => {
        dispatch(newsletterUpdateNewsletterCurrentWeek(ownProps.match.params.campaignId, week))
    },

    addItem: (listId, itemId) => {
        dispatch(newsletterAddNewsletterItem(ownProps.match.params.campaignId, listId, itemId))
    },

    deleteItem: (listId, itemId) => {
        dispatch(newsletterDeleteNewsletterItem(ownProps.match.params.campaignId, listId, itemId))
    },

    reorderItem: (listId, oldIndex, newIndex) => {
        dispatch(newsletterReorderNewsletterItem(ownProps.match.params.campaignId, listId, oldIndex, newIndex))
    },

    deleteItemComplete: (itemId, itemType) => {
        dispatch(newsletterDeleteElement(itemType + 's', itemId))
    },

    requestUpdateData: () => {
        dispatch(newsletterUpdateRequest())
    },

    sendNewsletter: (campaignId, items) => {
        dispatch(uiSetRequestOverlayType(OVERLAY_NEWSLETTER_SEND))
        dispatch(newsletterSendRequest(campaignId, items))
    },

    requestSendNewsletter: () => {
        dispatch(uiSetRequestOverlayType(OVERLAY_NEWSLETTER_YES_NO))
        dispatch(uiSetRequestOverlayRequest(actionTypes.NEWSLETTER_SEND_REQUEST))
    },

    cancelRequestSendNewsletter: () => {
        dispatch(newsletterCancelRequest())
        dispatch(uiRequestOverlayReset())
    },
})

const PageNewsletterCampaignContainer = ({
    match, 
    weeks, 
    currentWeek, 
    campaign, 
    cinemas, 
    hasChanges,

    currentCinemaId,
    currentClientCinemaId,
    multicinemaMode,

    hasSendNewsletter, 
    selectedItems, 
    movieOrder,
    movieData, 
    attributesData,
    adsData,
    highlightsData,
    elementsTextData,
    elementsImagesData,
    performancesData,

    caps,
    displayDropzones, 
    uiRequestOverlay, 
    updateWeek, 
    addItem, 
    deleteItem,
    deleteItemComplete,
    reorderItem,
    requestUpdateData,
    requestSendNewsletter, 
    sendNewsletter, 
    cancelRequestSendNewsletter, 
    sendStatus, 
    sendError
}) => {

    if(!campaign) {
        return ''
    }

    const newsletterCinemaId = campaign.cinema ? campaign.cinema : false
    const optionalCinemaId = getOptionalCinemaId(multicinemaMode, newsletterCinemaId, currentClientCinemaId)
    const weekObj = findWeekObWithIsoWeek(weeks, parseInt(currentWeek))
    const relevantMovies = filterMoviesByWeekAndCinema(movieOrder, movieData, performancesData, weekObj, optionalCinemaId)
    const relevantContent = filterItemsByCinema(Object.keys(adsData), adsData, optionalCinemaId)
    const relevantHighlights = filterItemsByCinema(Object.keys(highlightsData), highlightsData, optionalCinemaId)

    const filteredItemsData = {
        movies: {
            filteredItems: filterItemsByOrder(relevantMovies.relevant, movieData),
            filteredOrder: relevantMovies.relevant,
            current: relevantMovies.current,
            future: relevantMovies.future
        },
        content: {
            filteredItems: filterItemsByOrder(relevantContent, adsData),
            filteredOrder: relevantContent
        },
        highlights: {
            filteredItems: filterItemsByOrder(relevantHighlights, highlightsData),
            filteredOrder: relevantHighlights
        },
        text: {
            filteredItems: elementsTextData,
            filteredOrder: Object.keys(elementsTextData)
        },
        image: {
            filteredItems: elementsImagesData,
            filteredOrder: Object.keys(elementsImagesData)
        },
        attributes: filterAttributesByCinema(attributesData, optionalCinemaId)
    }

    return (
        <PageNewsletterCampaign
            pageName={campaign && campaign.name ? campaign.name : ''}
            weeks={weeks}
            currentWeek={currentWeek}
            cinemaId={optionalCinemaId} // ToDO
            campaignId={match.params.campaignId}
            campaign={campaign}
            hasSendNewsletter={hasSendNewsletter}
            selectedItems={selectedItems}
            hasChanges={hasChanges}
            filteredItemsData={filteredItemsData}
            canEditProgram={canEditProgram(caps)}
            canEditNewsletter={hasCap(caps, EDIT_NEWSLETTER_CAP)}
            uiRequestOverlay={uiRequestOverlay}
            displayDropzones={displayDropzones}
            updateWeek={updateWeek}
            addItem={addItem}
            reorderItem={reorderItem}
            deleteItem={deleteItem}
            deleteItemComplete={deleteItemComplete}
            requestUpdateData={requestUpdateData}
            requestSendNewsletter={requestSendNewsletter}
            sendNewsletter={sendNewsletter}
            cancelRequestSendNewsletter={cancelRequestSendNewsletter}
            sendStatus={sendStatus}
            sendError={sendError}
        />
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PageNewsletterCampaignContainer))